const theme = {
	base: 'rgba(255, 255, 255, 1)',
	base2: 'rgba(246, 245, 246, 1)',
	textPrimary: 'rgba(68, 68, 68, 1)',
	textSecondary: 'rgba(68, 68, 68, 0.48)',
	accent: 'rgba(8, 189, 186, 1)',
	accentSecondary: 'rgba(216, 246, 246, 1)',
	accentDarker: 'rgba(5, 157, 154, 1)',
	accentSecondaryDarker: 'rgba(168, 225, 225, 1)',
	red: 'rgba(219, 55, 55, 1)',
	shadow: 'rgba(50, 125, 123, 0.1)',
};

export default theme;
